'use client'
import { usePathname, useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { useCallback } from 'react'
import styles from './DataProcessingModal.module.css'
import I18nHtml from '@/components/I18nHtml'
import { Modal, Button } from 'design-system/client'
import { Routes } from '@/helpers/utils'
import type { Locale } from '@/i18n/types'

function DataProcessingModal({
  slug,
  channel,
  locale,
  receiverType,
}: {
  slug: string
  channel: string
  locale: Locale
  receiverType: 'projects' | 'fundraising-events'
}) {
  const t = useTranslations('nextjs.core')
  const router = useRouter()
  const onClose = useCallback(() => {
    router.push(Routes.donate({ slug, channel, locale, 'receiver-type': receiverType, 'catchAll': undefined }), {
      scroll: false,
    })
  }, [channel, locale, receiverType, router, slug])

  // navigating back with router.push with parallel routing does not close the modal
  const pathname = usePathname()
  if (!pathname.includes('data-processing')) return null

  return (
    <Modal
      id="data-processing-modal"
      title={t('newsletter_consent.platform.legal_modal.heading')}
      closeText={t('close')}
      onClose={onClose}
      onOpen={() => {}}
      isOpen
      customActions={
        <Button kind="primary" size="small" onClick={onClose} type="button" className={styles.closeModalButton}>
          {t('close')}
        </Button>
      }
    >
      <I18nHtml i18nKey="core.newsletter_consent.platform.legal_modal.content_html" />
    </Modal>
  )
}

export default DataProcessingModal
